<template>
  <div class="user-wrapper">
    <a v-if="whName!==''&&whName!==undefined" class="wh">
      {{ whName }}
    </a>
    <div class="content-box">
      <a href="https://www.megatech.com" target="_blank">
        <span class="action">
          <a-icon type="question-circle-o" />
        </span>
      </a>
      <!--      <notice-icon class="action"/>-->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
<!--          <a-avatar class="avatar" size="small" :src="avatar"/>-->
          <a-icon type="tool"></a-icon>
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <a-menu-item v-if="whName" key="0">
            <!--            <router-link :to="{ name: 'center' }">-->
            <!--              <a-icon type="user"/>-->
            <!--              <span>个人中心</span>-->
            <!--            </router-link>-->
            <a @click="handlePersonalCenter" href="javascript:">
              <a-icon type="user" />
              <span>{{ $t('menu.personalCenter') }}</span>
            </a>
          </a-menu-item>
          <a-menu-item v-if="whName" key="1">
            <!--            <router-link :to="{ name: 'settings' }">-->
            <!--              <a-icon type="setting"/>-->
            <!--              <span>账户设置</span>-->
            <!--            </router-link>-->
            <a @click="handlePassChange" href="javascript:">
              <a-icon type="setting" />
              <span>{{ $t('menu.accountSetting') }}</span>
            </a>
          </a-menu-item>
          <a-menu-item v-if="whName" key="2">
            <a @click="handleInvQuery" href="javascript:">
              <a-icon type="code-sandbox" />
              <span>{{ $t('menu.inventoryQuery') }}</span>
            </a>
          </a-menu-item>
          <a-menu-item key="3" disabled>
            <a @click="handleCalculator" href="javascript:">
              <a-icon type="calculator" />
              <span>{{ $t('menu.calculator') }}</span>
            </a>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="4">
            <a @click="handleSwitch" href="javascript:">
              <a-icon type="logout" />
              <span>{{ $t('menu.switchWarehouse') }}</span>
            </a>
          </a-menu-item>
          <a-menu-item key="5">
            <a @click="handleLogout" href="javascript:">
              <a-icon type="logout" />
              <span>{{ $t('menu.logout') }}</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <lang-select />
      <ScreenFull />
      <CalculatorModal ref="calculator" />
    </div>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import LangSelect from '@/components/tools/LangSelect'
import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import Vue from 'vue'
import CalculatorModal from '@/components/Calculator/CalculatorModal'
import ScreenFull from '@/components/tools/ScreenFull'
import { clearVue } from '@/utils/util'

export default {
  name: 'UserMenu',
  components: {
    CalculatorModal,
    LangSelect,
    NoticeIcon,
    ScreenFull
  },
  data: function() {
    return {
      warehouse: '',
      whName: '',
      executor: Vue.ls.get(OPERATOR)
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  created() {
    this.getWarehouse()
  },
  methods: {
    ...mapActions(['Logout']),
    handleLogout() {
      let that = this
      this.$confirm({
        title: that.$t('message.tip'),
        content: that.$t('message.confirmLogout'),
        onOk: () => {
          clearVue()
          setTimeout(() => {
            window.location.reload()
          }, 16)
          // return this.Logout({}).then(() => {
          //
          // }).catch(err => {
          //   this.$message.error({
          //     title: '错误',
          //     description: err.message
          //   })
          // })
        },
        onCancel() {
        },
        okText: that.$t('button.confirm'),
        cancelText: that.$t('button.cancel')
      })
    },
    handleSwitch() {
      let that = this
      this.$confirm({
        title: that.$t('message.tip'),
        content: that.$t('message.confirmSwitchWarehouse'),
        onOk: () => {
          if (this.executor.warehouses.length > 1) {
            this.$router.push({ name: 'warehouseSelect' })
          } else {
            this.$router.push({ name: 'login' })
          }
          Vue.ls.remove(WAREHOUSE)
        },
        onCancel() {
        },
        okText: that.$t('button.confirm'),
        cancelText: that.$t('button.cancel')
      })
    },
    getWarehouse() {
      this.warehouse = Vue.ls.get(WAREHOUSE)
      if (this.warehouse) {
        this.whName = this.warehouse.name
      }
    },
    handleCalculator() {
      this.$refs.calculator.visible = true
    },
    handlePassChange() {
      this.$router.push({ name: 'person' })
      //this.$router.push({ path: '/settings/person' })
      //this.$router.push({ name: 'analysis' })
    },
    handlePersonalCenter() {
      this.$router.push({ name: 'workLayout' })
    },
    handleInvQuery() {
      this.$router.push({ name: 'inventoryQuery' })
    }
  }
}
</script>

<style lang="less" scoped>
.wh {
  font-size: 20px;
  text-align: center;
  left: 45%;
  position: absolute;
  color: #c43708;
  font-weight: bold;
}
</style>